import { render } from "./DashboardAccordion.vue?vue&type=template&id=4356ee24&scoped=true"
import script from "./DashboardAccordion.vue?vue&type=script&lang=ts"
export * from "./DashboardAccordion.vue?vue&type=script&lang=ts"

import "./DashboardAccordion.vue?vue&type=style&index=0&id=4356ee24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4356ee24"

export default script